import shuffleLetters from "shuffle-letters";
import ValidateCaptcha from "../utils/validate_captcha";
import { Template, HorizontalMiddleMouseScroll, insertApprovedScript } from "../utils/helper";
import { HeroImageWithLink } from "../components/C_Hero";
import ScrollSpy from "../components/A_ScrollSpy";
import Localize from "../utils/initLocalization";
class About extends HTMLElement {
    hmmsCleanup = null;
    captchaDomReadyHandler = null;
    validateCaptchaDomReadyHandler = null;
    constructor() {
        super();
        this.render();
    }
    initCaptcha() {
        this.captchaDomReadyHandler = () => {
            const scriptUrl = "https://www.google.com/recaptcha/api.js";
            const scriptOptions = {
                scriptItself: scriptUrl,
                target: document.head,
                attributes: {
                    defer: true,
                    async: true
                }
            };
            try {
                insertApprovedScript(scriptOptions);
            }
            catch (error) {
                console.error("Error while inserting script:", error);
                return;
            }
            if (this.captchaDomReadyHandler) {
                document.removeEventListener("DOMContentLoaded", this.captchaDomReadyHandler);
                this.captchaDomReadyHandler = null;
            }
        };
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", this.captchaDomReadyHandler);
        }
        else {
            this.captchaDomReadyHandler();
        }
    }
    heroConfig = {
        name: "Derviş Öksüzoğlu",
        className: "heroLogoBg",
        link: "",
        imageSrc: "../assets/images/static/webp/logo.webp",
        srcSet: "../assets/images/static/webp/logo_256x256.webp 256w, ../assets/images/static/webp/logo_512x512.webp 512w, ../assets/images/static/webp/logo.webp 1024w"
    };
    skillConfigs = [
        {
            imageOne: "../assets/images/static/svg/tr.svg",
            imageTwo: "../assets/images/static/svg/uk.svg",
            title: Localize.translate("common:about:skills:teacher")
        },
        {
            imageOne: "../assets/images/static/svg/js.svg",
            imageTwo: "../assets/images/static/svg/ts.svg",
            title: Localize.translate("common:about:skills:frontend")
        }
    ];
    shuffleElements = [
        { selector: ".aside-title", multiple: false },
        { selector: ".aside-skill", multiple: true }
    ];
    SocialsElements = [
        { name: Localize.translate("common:about:socials:github"), icon: "bi bi-github", href: new URL("https://github.com/gokacinlar") },
        { name: Localize.translate("common:about:socials:hashnode"), icon: "bi bi-book", href: new URL("https://gokacinlar.hashnode.dev/") },
        { name: Localize.translate("common:about:socials:substack"), icon: "bi bi-substack", href: new URL("https://substack.com/@gokacinlar") },
        { name: Localize.translate("common:about:socials:email"), icon: "bi bi-mailbox", href: new URL("mailto:dervisoksuzoglu@tutamail.com?subject=To%20Dervi%C5%9F ") }
    ];
    render() {
        new Template().createTemplate(this.renderContent(), this);
    }
    initializeShuffleEffects() {
        this.shuffleElements.forEach(({ selector, multiple }) => {
            if (multiple) {
                document.querySelectorAll(selector).forEach(element => {
                    shuffleLetters(element);
                });
            }
            else {
                const element = document.querySelector(selector);
                if (element) {
                    shuffleLetters(element);
                }
            }
        });
    }
    renderContent() {
        return `
            <section id="about-grid" class="container-fluid mb-3">
                <div id="about-grid-parent" class="row gy-3 gx-3 px-2">
                    <div class="col-12 col-md-4 col-sm">
                        ${this.renderAside()}
                    </div>
                    <div class="col-12 col-md-8 col-sm">
                        ${this.renderMain()}
                    </div>
                </div>
            </section>
        `;
    }
    renderAside() {
        return `
        <aside id="about-aside" class="rounded-5 shadow-sm py-3 px-4 h-100">
            <div>
                ${this.renderHeroSection()}
                ${this.renderSkillsSection()}
                ${this.renderSocials()}
                ${this.renderMotto()}
            </div>
        </aside>
    `;
    }
    renderMain() {
        return `
        <section id="about-main" class="rounded-5 shadow-sm py-3 px-3 overflow-auto">
            ${new ScrollSpy().render()}
        </section>
    `;
    }
    renderHeroSection() {
        const { name, className, link, imageSrc, srcSet } = this.heroConfig;
        return `
            ${new HeroImageWithLink().render(name, className, link, imageSrc, srcSet)}
            <div class="pe-none">
                <h1 class="aside-title fw-medium mt-3 mb-0 text-center">${name}</h1>
                <hr class="border border-2 border-secondary">
            </div>
        `;
    }
    renderSkillsSection() {
        return `
            <div>
                ${this.skillConfigs.map(skill => this.renderSkill(skill)).join("")}
                <hr class="border border-2 border-secondary">
            </div>
        `;
    }
    renderSkill({ imageOne, imageTwo, title }) {
        return `
            <h2 class="aside-skill-name d-flex flex-row align-items-center gap-1 mb-1">
                <div class="d-flex align-items-center gap-1 px-1 py-1">
                    <img src="${imageOne}" class="aside-ico img-fluid lazyload rounded-1" loading="lazy" decoding="async">
                    <img src="${imageTwo}" class="aside-ico img-fluid lazyload rounded-1" loading="lazy" decoding="async">
                </div>
                <span class="aside-skill fs-4 text-start">${title}</span>
            </h2>
        `;
    }
    renderSocials() {
        return `
            <div class="d-flex flex-row flex-wrap align-items-start justify-content-evenly gap-1">
                ${this.SocialsElements.map(({ name, icon, href }) => `
                    <div class="aside-section-socials mb-2 rounded-pill shadow-sm flex-grow-1">
                        <a href="${href}" hreflang="x-default" class="d-flex flex-row align-items-center gap-1 px-2 py-2 link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover" 
                            target="_blank" title="${name}">
                            <i class="${icon} fs-3 px-1 py-1"></i>
                            <p class="aside-social-text h6 fw-medium mb-0">${name}</p>
                            <i class="bi bi-arrow-right fs-5 about-socials-arrow"></i>
                        </a>
                    </div>
                `).join("")}
            </div>
            <hr class="border border-2 border-secondary">
        `;
    }
    renderMotto() {
        return `
            <blockquote class="blockquote text-center mt-auto mb-auto">
                <p><em>${Localize.translate("common:misc:motto")}</em></p>
            </blockquote>
        `;
    }
    connectedCallback() {
        this.initializeShuffleEffects();
        this.initCaptcha();
        this.hmmsCleanup = new HorizontalMiddleMouseScroll().hmmsScroll(".scrollspy-nav");
        this.validateCaptchaDomReadyHandler = () => {
            new ValidateCaptcha().validate("submitCaptcha");
            if (this.validateCaptchaDomReadyHandler) {
                document.removeEventListener("DOMContentLoaded", this.validateCaptchaDomReadyHandler);
                this.validateCaptchaDomReadyHandler = null;
            }
        };
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", this.validateCaptchaDomReadyHandler);
        }
        else {
            this.validateCaptchaDomReadyHandler();
        }
    }
    disconnectedCallback() {
        if (this.hmmsCleanup) {
            this.hmmsCleanup();
            this.hmmsCleanup = null;
        }
        if (this.captchaDomReadyHandler) {
            document.removeEventListener("DOMContentLoaded", this.captchaDomReadyHandler);
            this.captchaDomReadyHandler = null;
        }
        if (this.validateCaptchaDomReadyHandler) {
            document.removeEventListener("DOMContentLoaded", this.validateCaptchaDomReadyHandler);
            this.validateCaptchaDomReadyHandler = null;
        }
    }
}
export default About;
customElements.define("app-about", About);
